<template>
    <button
        class="cart-product-line__tooltip-button button"
        @click="tooltipIsOpen = true"
    >
        <span>
            <i class="fal fa-question-circle"></i>
        </span>
    </button>
    <div
        v-if="tooltipIsOpen"
        class="cart-product-line__tooltip-modal"
    >
        <div class="d-flex justify-content-between mb-1">
            <h4>
                {{ $t("cart.tooltipModalTitle") }}
            </h4>
            <div class="algolia-listing-product-block__mobile-tooltip-close-button" @click="tooltipIsOpen = false">
                <i class="fas fa-times-circle"></i>
            </div>
        </div>
        <div>
            <ul>
                <li>
                    {{ $t("cart.tooltipModalBulletPointOne") }}
                </li>
                <li>
                    {{ $t("cart.tooltipModalBulletPointTwo") }}
                </li>
                <li>
                    {{ $t("cart.tooltipModalBulletPointThree") }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script setup>
import { ref } from "vue";

const tooltipIsOpen = ref(false);
</script>
